module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-circle-fill-a20c9ec5.svg";